import BaseService from './baseService';
import cloneDeep from 'lodash/cloneDeep'
class Transaction extends BaseService {
	async getTransactionBySubmissionId(id,opts = {}) {
    this.endPoint = '/transaction/'+id;
		return this.get(opts);
  }
  async getTransactionByCompanyId(payload) {
    this.endPoint = '/transaction-company';
    return this.post(payload);
  }
  async createTransaction(payload, opts = {}){
    this.endPoint = '/transaction';
    const newOpts = cloneDeep(opts, {
		  headers: {
			'Content-Type': 'multipart/form-data'
		  }
		})
	
		return await this.post(payload.data, newOpts)
  }
  // async updatePemasukan(id,payload,opts={}){
  //   this.endPoint = '/submission';
  //   return await this.putOne(id,payload,opts);
  // }
  async deleteTransaction(id,opts={}){
    this.endPoint = '/transaction';
    return await this.delete(id,opts);
  }
}

export default new Transaction();